var render = function () {
  var _obj, _obj$1, _obj$2, _obj$3
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition-group", { attrs: { name: "slide-fade", tag: "div" } }, [
        _vm.isToShow(4)
          ? _c(
              "a",
              {
                key: "secondDiv",
                staticClass: "btn",
                class:
                  ((_obj = {}),
                  (_obj[_vm.colorSelected] = _vm.isTipoChecked(4)),
                  (_obj[_vm.colorDeselected] = !_vm.isTipoChecked(4)),
                  (_obj["btn-circle"] = _vm.isButtonCircle()),
                  _obj),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.filterSelected(4)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" Emissão\n        "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isToShow(3)
          ? _c(
              "a",
              {
                key: "reali",
                staticClass: "btn",
                class:
                  ((_obj$1 = {}),
                  (_obj$1[_vm.colorSelected] = _vm.isTipoChecked(3)),
                  (_obj$1[_vm.colorDeselected] = !_vm.isTipoChecked(3)),
                  (_obj$1["btn-circle"] = _vm.isButtonCircle()),
                  _obj$1),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.filterSelected(3)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-check" }),
                _vm._v(" Realização\n        "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isToShow(2)
          ? _c(
              "a",
              {
                key: "mainDiv",
                staticClass: "btn",
                class:
                  ((_obj$2 = {}),
                  (_obj$2[_vm.colorSelected] = _vm.isTipoChecked(2)),
                  (_obj$2[_vm.colorDeselected] = !_vm.isTipoChecked(2)),
                  (_obj$2["btn-circle"] = _vm.isButtonCircle()),
                  _obj$2),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.filterSelected(2)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-clock-o" }),
                _vm._v(" Vencimento\n        "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isToShow(1)
          ? _c(
              "a",
              {
                key: "baixa",
                staticClass: "btn",
                class:
                  ((_obj$3 = {}),
                  (_obj$3[_vm.colorSelected] = _vm.isTipoChecked(1)),
                  (_obj$3[_vm.colorDeselected] = !_vm.isTipoChecked(1)),
                  (_obj$3["btn-circle"] = _vm.isButtonCircle()),
                  _obj$3),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.filterSelected(1)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-arrow-circle-down" }),
                _vm._v(" Baixa\n        "),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("transition-group", { attrs: { name: "slide-fade" } }, [
            _vm.isToShowBaixaDetails()
              ? _c(
                  "div",
                  { key: "baixaSubFilter", staticClass: "col-md-12" },
                  [
                    _c("gerenciais-filtro-baixa-tipo", {
                      attrs: {
                        colorSelected: _vm.colorSelected,
                        colorDeselected: _vm.colorDeselected,
                      },
                    }),
                    _vm._v(" "),
                    _c("hr"),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isVencimentoSelected()
              ? _c(
                  "div",
                  { key: "vencimentoSubFilter", staticClass: "col-md-12" },
                  [
                    _c("gerenciais-filtro-vencimento-tipo", {
                      attrs: {
                        colorSelected: _vm.colorSelected,
                        colorDeselected: _vm.colorDeselected,
                      },
                    }),
                    _vm._v(" "),
                    _c("hr"),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isIgnorarCompensadoEnabled() &&
            !_vm.isToShowBaixaDetails() &&
            !_vm.isVencimentoSelected()
              ? _c(
                  "div",
                  { key: "ignorarCompensadoEnabled", staticClass: "col-md-12" },
                  [
                    _c("gerenciais-filtro-ignorar-compensado", {
                      attrs: {
                        colorSelected: _vm.colorSelected,
                        colorDeselected: _vm.colorDeselected,
                      },
                    }),
                    _vm._v(" "),
                    _c("hr"),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }